import { render } from "./ViewCategoryModal.vue?vue&type=template&id=171a3103"
import script from "./ViewCategoryModal.vue?vue&type=script&lang=js"
export * from "./ViewCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__